import Common from '../../Common';

/*
interface PostBody {
	name: string
	origin?: string | number
}
*/

const Calendar = class extends Common {
	async create(profileId: id) {
		return this.post(`/profile/${profileId}/calendar`)
	}
}

export default Calendar;
